import { queryOptions } from "ui-common/query-options";
import { rpc } from "ui-common/services/rpc";

export const postsQueryOptions = queryOptions({
  queryKey: ["posts"],
  queryFn: () => rpc("postsQuery", undefined),
});
